import { WHITE, PURPLE } from '@colors';

const defaultTheme = {
  labelColor: 'rgba(255,255,255,0.5)',
  color: WHITE,
  borderColor: WHITE,
  labelFocusedColor: WHITE,
};

const getTheme = (theme) => {
  switch (theme) {
    case 'white':
      return defaultTheme;
    case 'purple':
      return {
        labelColor: 'PURPLE',
        color: PURPLE,
        borderColor: PURPLE,
        border: '2px solid',
        labelFocusedColor: PURPLE,
        IconColor: PURPLE,
      };
    case 'form':
      return {
        labelColor: 'rgb(131 0 114 / 0.5)',
        color: PURPLE,
        borderColor: PURPLE,
        backgroundColor: 'black !important',
        labelFocusedColor: PURPLE,
      };
    case 'grey':
      return {
        labelColor: '#9a9a9a85',
        color: '#000',
        borderColor: '#630557',
        labelFocusedColor: '#630557',
      };
    case 'transparentBorder':
      return {
        labelColor: PURPLE,
        color: PURPLE,
        borderColor: 'transparent',
        backgroundColor: 'black !important',
        labelFocusedColor: PURPLE,
        placeholderColor: PURPLE,
      };
    default:
      return defaultTheme;
  }
};

export { getTheme };
